import jsVectorMap from 'jsvectormap';
import './includes/us-merc.js';

window.SiteReady(($) => {

  console.log('Init Block: Region Map');

  //

  $('.js-region_map_container').each((_, container) => {
    const $container = $(container);

    const activeStates = $container.data('active-states');
    const activeMarkers = $container.data('active-markers');

    const map = new jsVectorMap({
      selector: '#' + $container.attr('id'),
      map: 'us_merc_en',
      zoomButtons: false,
      zoomOnScroll: false,
      regionStyle: {
        initial: {
          fill: '#bbbeda',
          fillOpacity: 1,
          stroke: '#ffffff',
          strokeWidth: 0.2,
        },
        hover: {
          fill: '#bbbeda',
          fillOpacity: 1,
        },
        selected: {
          fill: '#8386b1',
          fillOpacity: 1,
        },
        selectedHover: {
          fill: '#8386b1',
          fillOpacity: 1,
        },
      },
      selectedRegions: activeStates,
      markerStyle: {
        initial: {
          image: THEME_OPTIONS.theme_url + '/public/svg/marker_pin.svg',
          height: '30',
          width: '30',
        },
      },
      markers: activeMarkers,
      selectedMarkers: [0],
      onMarkerClick: (e, markerIndex) => {
        if (map._markers[markerIndex]) {
          const marker = map._markers[markerIndex];

          if (marker.config && marker.config.link) {
            window.location.href = marker.config.link;
          }
        }
      },
      onLoaded: (map) => {
        const debouncedResize = window.Debounce(() => {
          map.updateSize();
        }, 100);

        $(window).on('resize', debouncedResize);

        $.each(map._markers, (markerIndex, marker) => {
          if (marker.config && marker.config.id) {
            const $marker = $container.find('.jvm-marker[data-index="' + markerIndex + '"]');
            $marker.attr('id', marker.config.id);
          }
        });
      }
    });

  });

});